import React from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../Common/Loader/Loader';
import translate from '../../../services/translate/translate';

const withLoader = (WrappedComponent) => (props) => {
  const { creatingHPool, gettingDraftHPool } = useSelector((state) => state.createHPool);

  if (creatingHPool || gettingDraftHPool) {
    return (
      <div className="create-hpool-loader">
        <Loader message={translate(gettingDraftHPool ? 'loading.loading_hpool' : 'loading.create_hpool')} />
      </div>
    );
  }
  return <WrappedComponent {...props} />;
};

export default withLoader;
